const nl = {
	// Sidebar
	sidebarIntro: 'Hoi, mijn naam is Jordy en ik ben een full-stack webontwikkelaar. Bekijk hier mijn eerdere werk!',
	hireMe: 'Kom in contact',
	darkMode: 'Nachtmodus',
	switchLanguage: 'Selecteer taal',

	// Menu
	aboutMe: 'Over Mij',
	portfolio: 'Portfolio',
	resume: 'Resume',
	contact: 'Contact',

	// About me
	name: 'Jordy van der Poel',
	title: 'Full-stack web developer',
	view: 'Bekijk',
	aboutMeLong: 'Ik ben een software engineer gespeciliseerd in frontend en backend ontwikkeling voor complexe, scalable web applicaties. Meer weten over hoe ik jou kan helpen?',
	haveALook: 'Bekijk eens mijn',
	whatIDo: 'Wat Ik Doe',
	whatIDoLong: 'Ik heb meerdere jaren ervaring in het onwikkelen van maatwerk oplossingen voor verschillende opdrachtgevers. Hieronder zie je een overzicht van mijn technische skills and technologiën die ik gebruik. Meer weten over mijn ervaring?',
	checkOutMy: 'Bekijk mijn',
	onlineResume: 'online resume',
	and: 'en',
	projectPortfolio: 'project portfolio',
	featuredProjects: 'Uitgelichte Projecten',
	viewPortfolio: 'Bekijk Portfolio',

	// Resume
	downloadPDF: 'Download als PDF',
	resumeSummary1: 'Resultaatgedreven student informatica met een passie voor het helpen van anderen.',
	resumeSummary2: '5+ jaren ervaring in full-stack web ontwikkeling en enthousiast om nieuwe technologiën te leren.',
	workExperiences: 'Werkervaring',	
	projects: 'Projecten',	
	skills: 'Vaardigheden',	
	technical: 'Technisch',	
	professional: 'Professioneel',	
	education: 'Opleiding',	
	languages: 'Talen',	
	interests: 'Interesses',	
	technologies: 'Technologiën',	

	// Portfolio	
	earlierWorks: 'Bekijk mijn eerdere werk!',
	takingOnWork: 'Ik ben momenteel beschikbaar voor nieuwe freelance projecten.',
	wantHelp: 'Kan jij mij gebruiken bij het ontwikkelen van jouw website of webapplicatie?',
	viewProject: 'Bekijk Project',
	likeProjects: 'Spreekt een project je aan en wil je meer details? Laat het me weten!',

	// Contact
	interested: 'Geïnteresseerd in wat ik voor uw project kan betekenen, of alleen gedag zeggen?',
	sendEmail: 'Stuur me een e-mail naar',
	getConnected: 'In contact komen? Volg mij op onderstaande social media kanalen.',
};

export default nl;